import request from '@/api/request'
// ************************************************************************
// export function queryTimeList (data) {
//   // 获取开课的日期时间list
//   return request({ url: '/soutools/course/query/timeScope', method: 'post', data })
// }
export function queryCourseData (data) {
  // 获取项目二级数据
  return request({ url: '/soutools/v2/course/query/common', method: 'post', data })
}

export function ipqQueryCourseData (data) {
  // 获取ipq项目二级数据
  return request({ url: '/soutools/v2/course/query/ipq', method: 'post', data })
}

// 获取学科项目
export function queryTerritoryData (data) {
  return request({ url: '/territory/query/summary', method: 'post', data })
}

export function queryTimeList (data) {
  // 获取开课的日期时间list
  return request({ url: '/soutools/v2/course/query/timeScope', method: 'post', data })
}

// 封面列表
export function queryImageList1 (data) {
  // 获取开课的日期时间list
  return request({ url: '/imageClient/query/summary/image', method: 'post', data })
}

// 竞赛列表
export function queryCompetition (data) {
  // 获取开课的日期时间list
  return request({ url: '/soutools/v2/course/query/competition', method: 'post', data })
}
// 分享参数换ID
export function queryArgsToId (data) {
  return request({ url: '/course/argsToId', method: 'post', data })
}
// ID换参数
export function queryIdToArgs (data) {
  return request({ url: '/course/idToArgs', method: 'post', data })
}

// aihub
export function queryAiHub (data) {
  return request({ url: '/soutools/v2/course/query/aiHub', method: 'post', data })
}
